// MACHINERY V2 (Stroje) — the fleet CHROME below 1280 (M2.16a).
//
// The counterpart to FleetToolbar: same job, different shape. Below 1280 the
// FilterRail does not render AT ALL (not collapsed — absent; FleetShell owns
// that branch), and pattern B absorbs what the toolbar used to carry.
//
//   page head   -> FleetMobileHeader   (title · meta · + Pridat · kebab)
//   row 1       -> FilterBarB          (search · Filtre(n))
//   row 2       -> ActiveFilterChips   (only when filters are set)
//   the rest    -> FleetFilterSheet    (STAV · ZOSKUPIT · TYP · LOKACIA ·
//                                       ZOBRAZENIE · ROZSAH)
//
// >>> ONE FILTER STATE, NOT A PARALLEL ONE. <<< Every control here drives the
// SAME `machineryV2UiSlice` fields and the SAME `customerMachinery` query the
// rail and the toolbar drive. Nothing mirrors machine data into the UI slice,
// nothing keeps a second copy of a filter: rotate a tablet across 1280 and the
// rail comes back holding exactly what the sheet set.
//
// THE BADGE AND THE CHIPS ARE THE SAME LIST. `chips.length` is the number in
// the Filtre badge, so the two can never disagree about how many filters are on
// — which is what the board draws (badge "2" over two chips).
//
// IT FETCHES NOTHING. Like FleetShell, this reads the store and calls back into
// the page; every hook that issues a request — and therefore the single
// telemetry poller — stays in FleetPage.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React, { useState } from "react";

import { MachineryV2GroupBy } from "../machineryV2UiSlice";
import ActiveFilterChips from "../mobile/ActiveFilterChips";
import FilterBarB from "../mobile/FilterBarB";
import FleetFilterSheet from "./FleetFilterSheet";
import FleetMobileHeader from "./FleetMobileHeader";
import { FleetPageData } from "./fleetPageData";
import { FleetScope } from "./FleetToolbar";
import { useFleetActiveFilters } from "./fleetActiveFilters";

export interface FleetMobileChromeProps {
  data: FleetPageData;
  scope: FleetScope;
  onScopeChange: (scope: FleetScope) => void;
  search: string;
  onSearchChange: (value: string) => void;
  onSearchSubmit: () => void;
  onGroupByChange: (groupBy: MachineryV2GroupBy) => void;
  canWrite: boolean;
  onManageGroups: () => void;
  onAddMachine: () => void;
}

const FleetMobileChrome: React.FC<FleetMobileChromeProps> = ({
  data,
  scope,
  onScopeChange,
  search,
  onSearchChange,
  onSearchSubmit,
  onGroupByChange,
  canWrite,
  onManageGroups,
  onAddMachine,
}) => {
  const [sheetOpen, setSheetOpen] = useState(false);
  const { chips, clearAll } = useFleetActiveFilters(data);

  return (
    <>
      <FleetMobileHeader
        data={data}
        canWrite={canWrite}
        onManageGroups={onManageGroups}
        onAddMachine={onAddMachine}
      />

      <FilterBarB
        search={search}
        onSearchChange={onSearchChange}
        onSearchSubmit={onSearchSubmit}
        activeCount={chips.length}
        onOpenFilters={() => setSheetOpen(true)}
      />

      <ActiveFilterChips chips={chips} onClearAll={clearAll} />

      {/* Mounted whether or not it is open: Radix renders nothing while closed,
          and a persistent mount is what lets the draft survive a close and be
          re-seeded on the next open rather than remounted mid-gesture. */}
      <FleetFilterSheet
        open={sheetOpen}
        onOpenChange={setSheetOpen}
        data={data}
        scope={scope}
        onScopeChange={onScopeChange}
        onGroupByChange={onGroupByChange}
      />
    </>
  );
};

export default FleetMobileChrome;
